import React, { useState, useEffect } from 'react';
import chatApi from '../../../api/chatApi'

interface PromptSuggestionsProps {
    onSelect: (prompt: string) => void;
}

const PromptSuggestions: React.FC<PromptSuggestionsProps> = ({ onSelect }) => {
    const [prompts, setPrompts] = useState<string[]>([]);
    const [isVerified, setIsVerified] = useState(() => {
        return sessionStorage.getItem('approval_status') === 'true';
    });

    // Populate Prompts at Start
    useEffect(() => {
        const fetchPrompts = async () => {
            try {
                const res = await chatApi.getPrompts();
                setPrompts(res.map(p => p.question));

            } catch (error) {
                console.error("Failed to load prompts:", error);
            }
        };

        fetchPrompts();
    }, []);

    if (prompts.length === 0) return null;

    return (
        // Container: Width 830px, Gap 24px (gap-6)
        <div className="w-full max-w-[830px] flex gap-6 mb-6">
            {prompts.slice(0, 3).map((suggestion, index) => (
                <button
                    key={index}
                    onClick={() => onSelect(suggestion)}
                    disabled={!isVerified}
                    // Button: 
                    // - flex-1: Stretches to fill space (approx 260px)
                    // - h-[82px]: Fixed height
                    // - rounded-xl: Radius/Large
                    // - p-5: Padding/Medium (20px)
                    // - gap-2: Internal gap (8px)
                    className={`
                        flex-1 h-[82px] flex flex-col justify-center items-start gap-2
                        border rounded-xl p-5 text-left shadow-sm transition-all duration-200 
                        ${isVerified
                            ? 'bg-white border-gray-200 hover:bg-gray-50 hover:border-gray-300 cursor-pointer'
                            : 'bg-white border-gray-200 cursor-not-allowed opacity-60'
                        }
                    `}
                >
                    {/* Styling the text to look nice inside the large box */}
                    <span className={`font-sans text-sm leading-snug line-clamp-2 ${isVerified ? 'text-gray-700 font-medium' : 'text-gray-400'
                        }`}>
                        {suggestion}
                    </span>
                </button>
            ))}
        </div>
    );

};

export default PromptSuggestions;
